<template>
  <div id="div-with-loading" class="vs-con-loading__container img-bg">
    <!-- <pre>{{iconMap}}</pre> -->
    <!-- <div v-for="i in iconMap" :key="i">
{{ i.location  }} {{ i.class }}{{i.height}}
    </div> -->
    <br /><vs-row style="height: 5%" vs-w="12">
      <vs-col vs-lg="4" vs-sm="6" vs-xs="6">
        <vs-row vs-w="12">
          <vs-col>
            <div style="padding: 0px" class="roundedCard">
              <img
                class="ml-2"
                style="width: 40%; height: 35%"
                src="@/assets/images/frasers/5.png"
              /><img
                style="width: 30%; height: 30%"
                src="@/assets/images/frasers/output-onlinegiftools (34).gif"
              />
            </div> </vs-col
        ></vs-row>
      </vs-col> </vs-row
    ><br />
    <vs-row vs-w="12">
      <vs-col vs-w="6" vs-sm="12" vs-xs="12">
        <vs-row vs-w="12">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
          >
            <vs-card class="roundedCard">
              <vs-row>
                <vs-spacer />
                <vs-icon
                  @click="popupActivo4 = true"
                  icon="settings"
                  class="cursor-pointer"
                  size="20px"
                  color="dark"
                ></vs-icon>
              </vs-row>
              <div
                class="img-wraps"
                v-if="
                  ['Inside'].includes(select1) &&
                  ['2m', '6m', '10m', '12m'].includes(btnHeigth)
                "
              >
                <span
                  style="width: 22%; height: 25%"
                  :class="i.class"
                  v-for="i in this.filteredList"
                  :key="i"
                >
                  <vs-tooltip
                    :text="i.name + ' Temperature : ' + i.temperature"
                    :title="i.class"
                  >
                    <span
                      style="
                        font-size: 0.8rem;
                        position: absolute;
                        font-weight: 400;
                        width: 100%;
                        top: 36%;
                        color: white;
                        right: 2%;
                      "
                      >{{ i.temperature }}°C
                    </span>
                  </vs-tooltip>
                  <img
                    v-if="i.temperature >= optionsColor[0].value2"
                    style="width: 100%; height: 100%"
                    src="@/assets/icon/red.png"
                  />
                  <img
                    v-if="
                      i.temperature >= optionsColor[1].value1 &&
                      i.temperature <= optionsColor[1].value2
                    "
                    style="width: 100%; height: 100%"
                    src="@/assets/icon/yellow.png"
                  />
                  <img
                    v-if="
                      i.temperature >= optionsColor[2].value1 &&
                      i.temperature <= optionsColor[2].value2
                    "
                    style="width: 100%; height: 100%"
                    src="@/assets/icon/green.png"
                  />
                  <img
                    v-if="i.temperature <= optionsColor[3].value2"
                    style="width: 100%; height: 100%"
                    src="@/assets/icon/blue.png"
                  />
                </span>

                <img
                  class="imgMapFreacer"
                  src="@/assets/images/Freacer/undraw_product_iteration_kjok.png"
                />
              </div>
              <!-- <div
                class="img-wraps"
                v-if="
                  ['Inside'].includes(select1) &&
                  ['2m', '6m'].includes(btnHeigth)
                "
              >
                <span
                  style="width: 22%; height: 25%"
                  :class="i.class"
                  v-for="i in this.filteredList"
                  :key="i"
                >  <vs-tooltip :text="i.class">
                  <span
                    style="
                      font-size: 0.7rem;
                      position: absolute;
                      width: 100%;
                      top: 36%;
                      color: white;
                      right: 2%;
                    "
                    >{{ i.temperature }}°C
                  </span>
                  <img
                    v-if="i.temperature >= optionsColor[0].value2"
                    style="width: 90%; height: 100%"
                    src="@/assets/icon/red.png"
                  />
                  <img
                    v-if="
                      i.temperature >= optionsColor[1].value1 &&
                      i.temperature <= optionsColor[1].value2
                    "
                    style="width: 90%; height: 100%"
                    src="@/assets/icon/yellow.png"
                  />
                  <img
                    v-if="
                      i.temperature >= optionsColor[2].value1 &&
                      i.temperature <= optionsColor[2].value2
                    "
                    style="width: 90%; height: 100%"
                    src="@/assets/icon/green.png"
                  />
                  <img
                    v-if="i.temperature <= optionsColor[3].value2"
                    style="width: 90%; height: 100%"
                    src="@/assets/icon/blue.png"
                  /></vs-tooltip>
                </span>
                <img
                  class="imgMapFreacer"
                  src="@/assets/images/Freacer/undraw_product_iteration_kjok.png"
                />
              </div> -->
              <div class="img-wraps" v-else>
                <span
                  style="width: 22%; height: 25%"
                  :class="i.class"
                  v-for="i in this.filteredList"
                  :key="i"
                >
                  <vs-tooltip
                    v-if="['Left', 'Right'].includes(i.class)"
                    :text="i.name + ' Temperature : ' + i.temperature"
                    :title="i.class"
                  >
                    <span
                      style="
                        font-size: 0.8rem;
                        position: absolute;
                        font-weight: 400;
                        width: 100%;
                        top: 36%;
                        color: white;
                        right: 2%;
                      "
                      >{{ i.avgTemp }}°C
                    </span>
                  </vs-tooltip>
                  <vs-tooltip
                    v-else
                    :text="' ' + i.selectLocationTemp"
                    :title="i.class"
                  >
                    <span
                      style="
                        font-size: 0.8rem;
                        position: absolute;
                        font-weight: 400;
                        width: 100%;
                        top: 36%;
                        color: white;
                        right: 2%;
                      "
                      >{{ i.avgTemp }}°C
                    </span>
                  </vs-tooltip>
                  <img
                    v-if="i.avgTemp >= optionsColor[0].value2"
                    style="width: 100%; height: 100%"
                    src="@/assets/icon/red.png"
                  />
                  <img
                    v-if="
                      i.avgTemp >= optionsColor[1].value1 &&
                      i.avgTemp <= optionsColor[1].value2
                    "
                    style="width: 100%; height: 100%"
                    src="@/assets/icon/yellow.png"
                  />
                  <img
                    v-if="
                      i.avgTemp >= optionsColor[2].value1 &&
                      i.avgTemp <= optionsColor[2].value2
                    "
                    style="width: 100%; height: 100%"
                    src="@/assets/icon/green.png"
                  />
                  <img
                    v-if="i.avgTemp <= optionsColor[3].value2"
                    style="width: 100%; height: 100%"
                    src="@/assets/icon/blue.png"
                  />
                </span>

                <img
                  class="imgMapFreacer"
                  src="@/assets/images/Freacer/undraw_product_iteration_kjok.png"
                />
              </div>
            </vs-card>
          </vs-col>
        </vs-row>
        <vs-row vs-w="12">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="6"
            vs-sm="12"
            vs-xs="12"
          >
            <vs-card class="roundedCard" style="height: 92%">
              <vs-row>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="6"
                >
                  <img
                    style="width: 80%; height: 80%"
                    src="@/assets/images/frasers/output-onlinegiftools (33).gif"
                  />
                  <h3><b>Outside</b></h3>
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="6"
                >
                  <div style="text-align: center">
                    <img
                      class="mb-1"
                      style="width: 30%; height: 10%"
                      src="@/assets/images/frasers/15.png"
                    />

                    <b>
                      <p style="color: grey; font-size: 85%">
                        {{ this.datetime[0] }} {{ this.time[0] }}
                      </p></b
                    >
                  </div>
                </vs-col>
              </vs-row>
              <br />
              <vs-row
                vs-align="center"
                vs-type="flex"
                vs-justify="center"
                vs-w="12"
              >
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="6"
                >
                  <img
                    style="width: 25%; height: 70%"
                    src="@/assets/images/frasers/icon/thermometer.gif"
                  />
                  <h2 class="txttemp txtsize">
                    <b>{{ this.outsidetem }}°C</b>
                  </h2>
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="6"
                >
                  <img
                    style="width: 30%; height: 50%"
                    src="@/assets/images/frasers/icon/output-onlinegiftools (27).gif"
                  />
                  <h2 class="txthum txtsize">
                    <b>{{ this.outsidehum }}%</b>
                  </h2>
                </vs-col>
              </vs-row>
              <br />
            </vs-card>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="6"
            vs-sm="12"
            vs-xs="12"
          >
            <vs-card class="roundedCard" style="height: 92%">
              <vs-row>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="6"
                >
                  <img
                    style="width: 80%; height: 80%"
                    src="@/assets/images/frasers/output-onlinegiftools (36).gif"
                  />
                  <h3><b>Inside</b></h3>
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="6"
                >
                  <div style="text-align: center">
                    <img
                      class="mb-1"
                      style="width: 30%; height: 10%"
                      src="@/assets/images/frasers/15.png"
                    />

                    <b>
                      <p style="color: grey; font-size: 85%">
                        {{ this.datetime[0] }} {{ this.time[0] }}
                      </p></b
                    >
                  </div>
                </vs-col>
              </vs-row>
              <br />
              <vs-row
                vs-align="center"
                vs-type="flex"
                vs-justify="center"
                vs-w="12"
              >
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="6"
                >
                  <img
                    style="width: 25%; height: 70%"
                    src="@/assets/images/frasers/icon/thermometer.gif"
                  />
                  <h2 class="txttemp txtsize">
                    <b>{{ this.insidetem }}°C</b>
                  </h2>
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="6"
                >
                  <img
                    style="width: 30%; height: 50%"
                    src="@/assets/images/frasers/icon/output-onlinegiftools (27).gif"
                  />
                  <h2 class="txthum txtsize">
                    <b>{{ this.insidehum }}%</b>
                  </h2>
                </vs-col>
              </vs-row>
              <br />
            </vs-card>
          </vs-col>
        </vs-row>
      </vs-col>

      <vs-col vs-type="flex" vs-justify="center" vs-w="6" vs-sm="12" vs-xs="12">
        <vs-card class="roundedCard">
          <vs-row class="al-center"
            ><img
              style="width: 20%; height: 20%"
              src="@/assets/images/frasers/output-onlinegiftools (36).gif"
            />
            <h3><b>Inside</b></h3>

            <vs-spacer />
            <div class="mr-4">
              <p style="color: #fc8200" class="mb-1">avg</p>
              <p>{{ this.insidefiltem }}°C</p>
            </div>
            <div class="mr-4">
              <p style="color: #ff006a" class="mb-1">min</p>
              <p>{{ this.inmin }}°C</p>
            </div>
            <div class="mr-4">
              <p style="color: #d400ff" class="mb-1">max</p>
              <p>{{ this.inmax }}°C</p>
            </div>
          </vs-row>
          <vs-row>
            <vs-col
              style="padding: 0"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="12"
              vs-xs="12"
            >
              <div style="position: relative; width: 100%">
                <LineChart
                  :height="300"
                  :chartdata="chart_Data_inside"
                  :options="options_Chart"
                  :heightChart="400"
                />
                <!-- <Chart
                  :width="400"
                  :height="300"
                  :chartdata="this.datachartfillint"
                  :chartdata2="this.datachartfillinh"
                  :options="this.headerchart"
                /> -->
              </div>
            </vs-col>
            <vs-col
              style="padding: 0"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="3"
              vs-sm="12"
              vs-xs="12"
            >
              <div class="roundedCard">
                <br /><br />
                <vs-row class="container-fluid">
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="4"
                  >
                    <img
                      style="width: 60px; height: 60px"
                      src="@/assets/images/frasers/18.png"
                    />
                  </vs-col>
                  <vs-col vs-type="flex" vs-align="center" vs-w="7">
                    <h3 class="txttemp">
                      <b>{{ this.insidefiltem }}°C</b>
                    </h3>
                  </vs-col> </vs-row
                ><br />

                <vs-row class="container-fluid">
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="4"
                  >
                    <img
                      style="width: 60px; height: 60px"
                      src="@/assets/images/frasers/19.png"
                    />
                  </vs-col>
                  <vs-col vs-type="flex" vs-align="center" vs-w="7">
                    <h3 class="txthum">
                      <b>{{ this.insidefilhum }}%</b>
                    </h3>
                  </vs-col>
                </vs-row>
                <br />
                <br />
              </div>
            </vs-col>
          </vs-row>
          <br />
          <vs-row class="al-center">
            <img
              style="width: 20%; height: 20%"
              src="@/assets/images/frasers/output-onlinegiftools (33).gif"
            />
            <h3><b>Outside</b></h3>
            <vs-spacer />
            <div class="mr-4">
              <p style="color: #fc8200" class="mb-1">avg</p>
              <p>{{ this.outsidefiltem }}°C</p>
            </div>
            <div class="mr-4">
              <p style="color: #ff006a" class="mb-1">min</p>
              <p>{{ this.outmin }}°C</p>
            </div>
            <div class="mr-4">
              <p style="color: #d400ff" class="mb-1">max</p>
              <p>{{ this.outmax }}°C</p>
            </div>
          </vs-row>
          <vs-row>
            <vs-col
              style="padding: 0"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="12"
              vs-xs="12"
            >
              <div style="position: relative; width: 100%">
                
                <LineChart
                  :height="300"
                  :chartdata="chart_Data_outside"
                  :options="options_Chart"
                  :heightChart="400"
                />
                <!-- <Chart
                  :width="400"
                  :height="300"
                  :chartdata="this.datachartfilloutt"
                  :chartdata2="this.datachartfillouth"
                  :options="this.headerchart"
                /> -->
              </div>
            </vs-col>
            <vs-col
              style="padding: 0"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="3"
              vs-sm="12"
              vs-xs="12"
            >
              <div class="roundedCard">
                <br /><br />
                <vs-row class="container-fluid">
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="4"
                  >
                    <img
                      style="width: 60px; height: 60px"
                      src="@/assets/images/frasers/18.png"
                    />
                  </vs-col>
                  <vs-col vs-type="flex" vs-align="center" vs-w="7">
                    <h3 class="txttemp">
                      <b>{{ this.outsidefiltem }}°C</b>
                    </h3>
                  </vs-col> </vs-row
                ><br />

                <vs-row class="container-fluid">
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="4"
                  >
                    <img
                      style="width: 60px; height: 60px"
                      src="@/assets/images/frasers/19.png"
                    />
                  </vs-col>
                  <vs-col vs-type="flex" vs-align="center" vs-w="7">
                    <h3 class="txthum">
                      <b>{{ this.outsidefilhum }}%</b>
                    </h3>
                  </vs-col>
                </vs-row>
                <br />
                <br />
              </div>
            </vs-col>
          </vs-row>
        </vs-card>
      </vs-col>
    </vs-row>
    <b-modal id="modal-settingColum" hide-header centered size="lg">
      <h4
        class="mb-4 colorSuccess"
        style="font-size: 1.125rem; font-weigth: 500"
      >
        Sensor List Settings
      </h4>
      <span>Select Parameter</span>
      <vs-row vs-w="12">
        <vs-col
          :disabled="visibleFields.length == 1 && field.visible"
          v-for="field in fields"
          :key="field.key"
          style="padding: 0"
          vs-type="flex"
          vs-align="center"
          vs-lg="4"
          class="mt-3"
          vs-sm="4"
          vs-xs="12"
        >
          <vs-checkbox class="col-checkbox" v-model="field.visible">
            {{ field.label }}</vs-checkbox
          >
        </vs-col>
      </vs-row>

      <template #modal-footer>
        <vs-button class="brdbtn" color="success" type="filled"
          >Submit</vs-button
        >
        <vs-button class="brdbtn" color="dark" type="flat">Cancel</vs-button>
      </template>
    </b-modal>

    <b-modal
      scrollable
      id="modal-settingMap"
      ref="settingMap"
      no-close-on-backdrop="false"
      hide-header
      centered
      size="lg"
    >
      <h4
        class="mb-4 colorSuccess"
        style="font-size: 1.125rem; font-weigth: 500"
      >
        Map Settings
      </h4>
      <br />
      <vs-row vs-w="12">
        <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
          <div class="img-wraps">
            <span
              style="width: 22%; height: 25%"
              :class="i.class"
              v-for="i in filteredList"
              :key="i"
            >
              <img
                v-if="i.type == select1"
                style="width: 100%; height: 100%"
                src="@/assets/icon/black.png"
              />
              <img
                v-if="select1 == 'Custom'"
                style="width: 100%; height: 100%"
                src="@/assets/icon/black.png"
              />
              <img
                v-if="select1 == 'Default'"
                style="width: 100%; height: 100%"
                src="@/assets/icon/black.png"
              />
            </span>
            <img
              class="imgMapFreacer"
              src="@/assets/images/Freacer/undraw_product_iteration_kjok.png"
            />
          </div>
        </vs-col>
        <vs-col class="mt-4" vs-type="flex" vs-lg="6" vs-sm="12" vs-xs="12">
          <div>
            <vs-select
              class="mb-4 mt-2"
              width="300px"
              label="Select Location"
              v-model="select1"
            >
              <vs-select-item
                :key="index"
                :value="item.text"
                :text="item.text"
                v-for="(item, index) in optionsMap"
              />
            </vs-select>
            <vs-select
              v-if="['Custom'].includes(select1)"
              class="mb-4 mt-2"
              width="300px"
              multiple
              label="Select Location"
              v-model="selectLocation"
            >
              <vs-select-item
                :key="index"
                :value="item.text"
                :text="item.text"
                v-for="(item, index) in optionsMap2"
              />
            </vs-select>
            <vs-select
              v-if="
                ['Custom'].includes(select1) &&
                selectLocation.includes('Inside')
              "
              class="mb-4 mt-2"
              width="300px"
              multiple
              label="Select Device Hight"
              v-model="selectHeightMap"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in optionsHeight"
              />
            </vs-select>
            <vs-select
              v-if="
                ['Custom'].includes(select1) &&
                selectLocation.includes('Outside')
              "
              class="mb-4 mt-2"
              width="300px"
              multiple
              label="Select Device Hight"
              v-model="selectAreaMap"
            >
              <vs-select-item
                :key="index"
                :value="item.text"
                :text="item.text"
                v-for="(item, index) in optionsHeightOutside"
              />
            </vs-select>
            <vs-select
              v-if="['Custom'].includes(select1)"
              width="300px"
              class="mb-4 mt-2"
              label="Select device"
              label-placeholder="Multiple"
              multiple
              v-model="selectDevice"
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.name"
                v-for="(item, index) in filterSelectDevice"
              />
            </vs-select>
            <span
              class="mb-2"
              style="
                font-size: 0.85rem;
                padding-left: 5px;
                color: rgba(0, 0, 0, 0.6);
              "
              >Select Color Rulse</span
            >
            <vs-row
              class="mb-3 mt-3"
              v-for="i in optionsColor"
              :key="i"
              vs-w="12"
            >
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="3"
                vs-sm="4"
                vs-xs="3"
              >
                <span :class="i.color">{{ i.text }}</span>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="3"
                vs-sm="4"
                vs-xs="2"
              >
                <input
                  v-if="i.value1"
                  type="”number”"
                  style="
                    width: 100%;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    padding: 0.4rem;
                  "
                  v-model="i.value1"
                />
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="2"
                vs-sm="4"
                vs-xs="1"
              >
                {{ i.icon }}
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="3"
                vs-sm="4"
                vs-xs="2"
              >
                <input
                  type="”number”"
                  style="
                    width: 100%;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    padding: 0.4rem;
                  "
                  v-model="i.value2"
                />
              </vs-col>
            </vs-row>
          </div>
        </vs-col>
      </vs-row>
      <template #modal-footer>
        <vs-button
          class="brdbtn"
          color="success"
          @click="
            saveMapsetting(
              optionsColor,
              select1,
              selectHeightMap,
              selectDevice,
              selectAreaMap,
              selectLocation,
              filteredList
            )
          "
          type="filled"
          >Submit</vs-button
        >
        <vs-button
          class="brdbtn"
          color="dark"
          @click="cancelMapsetting"
          type="flat"
          >Cancel</vs-button
        >
      </template>
    </b-modal>

    <vs-popup
      button-close-hidden
      fullscreen
      title="Map Settings"
      :active.sync="popupActivo4"
      ><br />
      <!-- <pre>{{filteredList}}</pre> -->
      <vs-row vs-w="12">
        <vs-col style="text-align: center" vs-lg="6" vs-sm="12" vs-xs="12">
          <div class="img-wraps">
            <span
              style="width: 22%; height: 25%"
              :class="i.class"
              v-for="i in filteredList"
              :key="i"
            >
              <img
                v-if="i.type == select1"
                style="width: 100%; height: 100%"
                src="@/assets/icon/black.png"
              />
              <img
                v-if="select1 == 'Custom'"
                style="width: 100%; height: 100%"
                src="@/assets/icon/black.png"
              />
              <img
                v-if="select1 == 'Default'"
                style="width: 100%; height: 100%"
                src="@/assets/icon/black.png"
              />
            </span>
            <img
              class="imgMapFreacer"
              src="@/assets/images/Freacer/undraw_product_iteration_kjok.png"
            />
          </div>
          <br /><br />
          <vs-row class="mb-1"><vs-spacer /> </vs-row>
          <vs-row v-if="['Inside'].includes(select1)"
            ><vs-spacer />
            <p
              class="mr-2"
              style="font-size: 0.85rem; color: rgba(0, 0, 0, 0.6)"
            >
              Select Height :
            </p>
            <div v-for="i in optionsHeight" :key="i">
              <vs-radio
                v-model="btnHeigth"
                class="mr-2"
                vs-name="radios1"
                @click="search(i.value)"
                :vs-value="i.value"
                >{{ i.text }}</vs-radio
              >
            </div></vs-row
          >
        </vs-col>
        <vs-col class="mt-4" vs-type="flex" vs-lg="6" vs-sm="12" vs-xs="12">
          <div>
            <vs-select
              class="mb-4 mt-2"
              width="300px"
              label="Select Mode"
              v-model="select1"
            >
              <vs-select-item
                :key="index"
                :value="item.text"
                :text="item.text"
                v-for="(item, index) in optionsMap"
              />
            </vs-select>
            <vs-select
              v-if="['Custom'].includes(select1)"
              class="mb-4 mt-2"
              width="300px"
              multiple
              label="Select Location"
              v-model="selectLocation"
            >
              <vs-select-item
                :key="index"
                :value="item.text"
                :text="item.text"
                v-for="(item, index) in optionsMap2"
              />
            </vs-select>
            <vs-select
              v-if="
                ['Custom'].includes(select1) &&
                selectLocation.includes('Outside')
              "
              class="mb-4 mt-2"
              width="300px"
              multiple
              label="Select Device Area"
              v-model="selectAreaMap"
            >
              <vs-select-item
                :key="index"
                :value="item.text"
                :text="item.text"
                v-for="(item, index) in optionsHeightOutside"
              />
            </vs-select>
            <vs-select
              v-if="
                ['Custom'].includes(select1) &&
                selectLocation.includes('Inside')
              "
              class="mb-4 mt-2"
              width="300px"
              multiple
              label="Select Device Height"
              v-model="selectHeightMap"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in optionsHeight2"
              />
            </vs-select>
            <vs-select
              v-if="['Custom'].includes(select1)"
              width="300px"
              class="mb-4 mt-2"
              label="Select Device"
              label-placeholder="Multiple"
              multiple
              v-model="selectDevice"
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.name"
                v-for="(item, index) in filterSelectDevice"
              />
            </vs-select>

            <span
              class="mb-2"
              style="
                font-size: 0.85rem;
                padding-left: 5px;
                color: rgba(0, 0, 0, 0.6);
              "
              >Select Color Rulse</span
            >
            <vs-row
              class="mb-3 mt-3"
              v-for="i in optionsColor"
              :key="i"
              vs-w="12"
            >
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="3"
                vs-sm="4"
                vs-xs="3"
              >
                <span :class="i.color">{{ i.text }}</span>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="3"
                vs-sm="4"
                vs-xs="2"
              >
                <input
                  v-if="i.value1"
                  type="”number”"
                  style="
                    width: 100%;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    padding: 0.4rem;
                  "
                  v-model="i.value1"
                />
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="2"
                vs-sm="4"
                vs-xs="1"
              >
                {{ i.icon }}
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="3"
                vs-sm="4"
                vs-xs="2"
              >
                <input
                  type="”number”"
                  style="
                    width: 100%;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    padding: 0.4rem;
                  "
                  v-model="i.value2"
                />
              </vs-col>
            </vs-row>
          </div>
        </vs-col>
      </vs-row>
      <br />
      <vs-row>
        <vs-spacer />
        <vs-button
          class="brdbtn mr-1"
          color="success"
          @click="
            saveMapsetting(
              optionsColor,
              select1,
              selectHeightMap,
              selectDevice,
              selectAreaMap,
              selectLocation,
              filteredList,
              btnHeigth
            )
          "
          type="filled"
          >Submit</vs-button
        >
        <vs-button
          class="brdbtn"
          color="dark"
          @click="cancelMapsetting"
          type="flat"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
  </div>
</template>
<script>
import LineChart from "@/components/ChartJs/LineChart.vue";
import MiniChart from "./MiniChart.vue";
import { Datetime } from "vue-datetime";
import axios from "axios";
import moment from "moment";
export default {
  name: "CustomDashboard",
  components: {
    LineChart,
    MiniChart,
    datetime: Datetime,
  },
  data: () => ({
    dataP: "",
    chart_Data_inside: {
      datasets: [
        {
          data: [],
          label: "Temperature ( °C )",
          borderWidth: 1.5,
          backgroundColor: "rgba(172, 0, 252,.1)",
          borderColor: "rgba(172, 0, 252,.9)",
          //     backgroundColor:  this.gradient,
        },
        {
          data: [],
          label: "Humid ( % )",
          backgroundColor: "rgba(20, 153, 242,.1)",
          borderWidth: 1.5,
          borderColor: "rgba(20, 153, 242,.9)",

          //     backgroundColor:  this.gradient,
        },
      ],
      labels: [],
    },
    chart_Data_outside: {
      datasets: [
        {
          data: [],
          label: "Temperature ( °C )",
          borderWidth: 1.5,
          backgroundColor: "rgba(172, 0, 252,.1)",
          borderColor: "rgba(172, 0, 252,.9)",
          //     backgroundColor:  this.gradient,
        },
        {
          data: [],
          label: "Humid ( % )",
          backgroundColor: "rgba(20, 153, 242,.1)",
          borderWidth: 1.5,
          borderColor: "rgba(20, 153, 242,.9)",

          //     backgroundColor:  this.gradient,
        },
      ],
      labels: [],
    },
    options_Chart: {
      maintainAspectRatio: false,
      responsive: true,
      legend: {
        position: "bottom",
      },
    },
    pages3: [{ text: "Page 1" }, { text: "Page 2" }, { text: "Page 3" }],
    popupActivo4: false,
    checkBox1: "",
    primeFilter: [],
    currentFilter: "",
    descriptionItems: [3, 5, 15],
    select1: "",
    selectLocation: [],
    selectHeightMap: [],
    selectAreaMap: [],
    selectDevice: [],
    idDeviceList: [],
    device: [],
    optionsMap: [
      { text: "Default" },
      { text: "Inside" },
      { text: "Outside" },
      { text: "Custom" },
    ],
    optionsMap2: [{ text: "Inside" }, { text: "Outside" }],
    optionsHeight: [
      { text: "All", value: "" },
      { text: "2m", value: "2m" },
      { text: "6m", value: "6m" },
      { text: "10m", value: "10m" },
      { text: "12m", value: "12m" },
    ],
    optionsHeight2: [
      // { text: "All", value: "" },
      { text: "2m", value: "2m" },
      { text: "6m", value: "6m" },
      { text: "10m", value: "10m" },
      { text: "12m", value: "12m" },
    ],
    optionsHeightOutside: [{ text: "Left" }, { text: "Right" }],
    optionsID: [
      { text: "6 meters", value: "6m" },
      { text: "2 meters", value: "2m" },
    ],
    sensorList: [],
    iconMap: [],
    iconMapChart: [],
    fields: [
      { key: "date", label: "Timestamp", visible: true },
      { key: "id", label: "Device No.", visible: true },
      { key: "temperature", label: "Temperature (°C)", visible: true },
      { key: "humidity", label: "Humidity", visible: true },
      { key: "location", label: "Location", visible: true },
      { key: "height", label: "Height", visible: true },
      { key: "color", label: "Battery", visible: true },
    ],
    optionsColor: [
      { text: "Red", icon: ">", color: "textDanger", value2: "" },
      {
        text: "Yellow",
        icon: "-",
        color: "textYellow",
        value1: "",
        value2: "",
      },
      {
        text: "Green",
        icon: "-",
        color: "colorSuccess",
        value1: "",
        value2: "",
      },
      { text: "Blue", icon: "<", color: "textBlue", value2: 21 },
    ],
    headerList: [
      { text: "Timestamp", visible: true },
      { text: "Device No.", visible: true },
      { text: "Temperature (°C)", visible: true },
      { text: "Humidity", visible: true },
      { text: "Location", visible: true },
      { text: "Hight", visible: true },
      { text: "Battery", visible: true },
    ],
    lo: [],
    arraylo: [],
    averageTemp: [],
    test: [],
    insidetem: 0,
    insidehum: 0,
    outsidetem: 0,
    outsidehum: 0,
    datetime: "",
    time: "",
    selectHeight: [],
    selectSide: [],
    optionsSide: [
      { text: "left", value: "left" },
      { text: "right", value: "right" },
    ],
    headerList: [
      "Timestamp",
      "Device No.",
      "Temperature",
      "Humidity",
      "Location",
      "Hight",
      "Battery",
    ],
    users: [],
    btnHeigth: "",

    ////P
    headerchart: [],
    datachart: [],
    datachartout: [],
    datachart2: [],
    datachart2out: [],
    datachartfillint: [],
    datachartfillinh: [],
    datachartfilloutt: [],
    datachartfillouth: [],
    insidefiltem: 0,
    insidefilhum: 0,
    outsidefiltem: 0,
    outsidefilhum: 0,
    insidefil: 0,
    outsidefil: 0,
    inmin: 0,
    inmax: 0,
    outmin: 0,
    outmax: 0,
    interval: null,
    users: [],
    default_map: [],
    groupedByHour: ([] = []),
  }),
  // beforeCreate() {
  //   this.$API.get("sensor/indoor/frasers").then((res) => {
  //     this.fetchChart(res.data);
  //     this.openLoadingInDiv();
  //   });
  // },
  async mounted() {
    this.callapi();
    this.getMapsetting();
  },
  beforeDestroy() {
    clearTimeout(this.interval);
  },
  methods: {
    async getMapsetting() {
      try {
        await this.$API.get(`dashboard/config/map/1`).then((result) => {
          this.test = result.data;
          // console.log(result.data);
          this.optionsColor[0].value2 = result.data[0].red;
          this.optionsColor[1].value1 = result.data[0].yellow[0];
          this.optionsColor[1].value2 = result.data[0].yellow[1];
          this.optionsColor[2].value1 = result.data[0].green[0];
          this.optionsColor[2].value2 = result.data[0].green[1];
          this.optionsColor[3].value2 = result.data[0].blue;
          this.select1 = result.data[0].device_location;
          this.selectHeightMap = result.data[0].device_height;
          this.selectDevice = result.data[0].device;
          this.selectLocation = result.data[0].select_location;
          this.selectAreaMap = result.data[0].device_area_map;
          this.btnHeigth = result.data[0].height;
        });
      } catch (error) {
        console.log(error);
      }
    },
    async callapi() {
      try {
        var text = 0;
        var count = 0;
        // this.openLoadingInDiv();
        const average = (arr) => arr.reduce((p, c) => p + c, 0) / arr.length;
        let result = await this.$API.get(`sensor/network/115/frasers`);
        this.Allside_avg(result.data);
        result.data.forEach(async (element) => {
          this.idDeviceList.push({
            id: element.id,
          });
          if (element.location != "Outside") {
            let filteredData = result.data.filter(
              (data) => data.location == element.location
            );
            element.avgTemp = (
              filteredData.reduce(
                (total, next) => total + next.temperature,
                0
              ) / filteredData.length
            ).toFixed(1);
            element.avgHumd = (
              filteredData.reduce((total, next) => total + next.humidity, 0) /
              filteredData.length
            ).toFixed(1);
            element.nameTempA = element.temperature;
            //compute temperature&humdity by location
            element.selectLocationTemp = [];
            element.selectLocationHumd = [];
            await filteredData.forEach((data) => {
              element.selectLocationTemp.push(
                data.name + " Temperature : " + data.temperature + "°C \n"
              );
              element.selectLocationHumd.push(data.humidity);
            });
          } else {
            element.avgTemp = element.temperature.toFixed(1);
          }
        });
        // console.log(result.data);
        this.iconMap = result.data;
        result = await this.$API.get(`sensor/indoor/frasers`);
        result.data.forEach((element) => {
          this.idDeviceList.push({
            id: element.id,
          });
          if (element.location != "Outside") {
            let filteredData = result.data.filter(
              (data) => data.location == element.location
            );
            element.avgTemp = (
              filteredData.reduce(
                (total, next) => total + next.temperature,
                0
              ) / filteredData.length
            ).toFixed(1);
            element.avgHumd = (
              filteredData.reduce((total, next) => total + next.humidity, 0) /
              filteredData.length
            ).toFixed(1);
            element.nameTempA = element.temperature;
          } else {
            element.avgTemp = element.temperature.toFixed(1);
          }
        });
        console.log(result.data);
        this.iconMapChart = result.data;

        // await this.$API.get("sensor/network/115/frasers").then((res) => {
        //   this.Allside_avg(res.data);
        //   const datenow = moment().format();
        //   this.datetime = datenow.split("T");
        //   const timechange = this.datetime[1];
        //   this.time = timechange.split("+");
        //   this.allsidefilter_avg(this.filteredListChart);
        //   this.fetchChartfilter(this.filteredListChart);
        // });

        const datenow = moment().format();
        this.datetime = datenow.split("T");
        const timechange = this.datetime[1];
        this.time = timechange.split("+");
        this.allsidefilter_avg(this.filteredListChart);
        this.fetchChartfilter(this.filteredListChart);
      } catch (error) {
        console.log(error);
      }
      this.interval = setTimeout(() => {
        this.callapi();
      }, 1000 * 60);
    },
    openLoadingInDiv() {
      this.$vs.loading({
        scale: 1,
        type: "radius",
      });
      setTimeout(() => {
        this.$vs.loading.close();
      }, 2200);
    },
    fetchChartfilter(data) {
      const timedd = [];
      data.forEach((sensordata) => {
        const date = sensordata.timestamp;
        this.date = moment(date).format("hh A");
        timedd.push(this.date);
      });
      this.timedd2 = [...new Set(timedd)];
      this.headerchart = this.timedd2;
      this.groupedByHour = data.reduce((result, item) => {
        let hour = moment(item.timestamp).format("hh A");
        result[hour] = result[hour] || [];
        result[hour].push(item);
        return result;
      }, []);

      var tempIn = 0;
      var humpIn = 0;
      var tempOut = 0;
      var humpOut = 0;
      var dataSumtemp = [];
      var dataSumhump = [];
      var dataSumtempout = [];
      var dataSumhumpout = [];
      for (var i = 0; i < Object.values(this.groupedByHour).length; i++) {
        var j = 0;
        var k = 0;
        Object.values(this.groupedByHour)[i].forEach((e, i) => {
          if (e.type == "Inside") {
            tempIn += e.data.temperature;
            humpIn += e.data.humidity;
            j++;
          } else if (e.type == "Outside") {
            tempOut += e.data.temperature;
            humpOut += e.data.humidity;
            k++;
          }
        });
        tempIn = tempIn / j;
        humpIn = humpIn / j;
        tempOut = tempOut / k;
        humpOut = humpOut / k;
        tempIn = parseFloat(tempIn.toFixed(1));
        humpIn = parseFloat(humpIn.toFixed(1));
        tempOut = parseFloat(tempOut.toFixed(1));
        humpOut = parseFloat(humpOut.toFixed(1));
        dataSumtemp.push(tempIn);
        dataSumhump.push(humpIn);
        dataSumtempout.push(tempOut);
        dataSumhumpout.push(humpOut);
        humpIn = 0;
        tempIn = 0;
        humpOut = 0;
        tempOut = 0;
      }
      const data2 = dataSumtemp;
      const data3 = dataSumhump;
      const data4 = dataSumtempout;
      const data5 = dataSumhumpout;
      this.datachartfillint = data2;
      this.datachartfillinh = data3;
      this.datachartfilloutt = data4;
      this.datachartfillouth = data5;
      this.chart_Data_inside.labels = this.headerchart;
      this.chart_Data_inside.datasets[0].data = this.datachartfillint;
      this.chart_Data_inside.datasets[1].data = this.datachartfillinh;
      this.chart_Data_outside.labels = this.headerchart;
      this.chart_Data_outside.datasets[0].data = this.datachartfilloutt;
      this.chart_Data_outside.datasets[1].data = this.datachartfillouth;
    },
    search(btn) {
      let data = this.primeFilter.filter((element) => element.height == btn);
      this.btnHeigth = btn;
    },
    Allside_avg(amout) {
      // console.log(amout);
      this.insidetem = 0;
      this.insidehum = 0;
      this.outsidetem = 0;
      this.outsidehum = 0;
      var inside = 0;
      var outside = 0;
      amout.forEach((users) => {
        if (users.type === "Inside") {
          this.insidetem += users.temperature;
          this.insidehum += users.humidity;
          inside++;
        } else if (users.type === "Outside") {
          this.outsidetem += users.temperature;
          this.outsidehum += users.humidity;
          outside++;
        }
      });
      this.outsidetem = this.outsidetem / outside;
      this.outsidetem = this.Decimalavg(this.outsidetem);
      this.outsidehum = this.outsidehum / outside;
      this.outsidehum = this.Decimalavg(this.outsidehum);
      this.insidetem = this.insidetem / inside;
      this.insidetem = this.Decimalavg(this.insidetem);
      this.insidehum = this.insidehum / inside;
      this.insidehum = this.Decimalavg(this.insidehum);
    },
    allsidefilter_avg(amout, datachart) {
      this.insidefiltem = 0;
      this.insidefilhum = 0;
      this.outsidefiltem = 0;
      this.outsidefilhum = 0;
      this.insidefil = 0;
      this.outsidefil = 0;
      this.inmin = 0;
      this.inmax = 0;
      this.outmin = 0;
      this.outmax = 0;
      const inminmax = [];
      const outminmax = [];
      const ArrayList = amout;
      ArrayList.forEach((filteredList) => {
        if (filteredList.type === "Inside") {
          this.insidefiltem += filteredList.temperature;
          this.insidefilhum += filteredList.humidity;
          this.insidefil++;
          inminmax.push(filteredList.temperature);
        } else if (filteredList.type === "Outside") {
          this.outsidefiltem += filteredList.temperature;
          this.outsidefilhum += filteredList.humidity;
          this.outsidefil++;
          outminmax.push(filteredList.temperature);
        }
      });
      if (this.insidefil != 0) {
        this.inmin = Math.min(...inminmax).toFixed(1);
        this.inmax = Math.max(...inminmax).toFixed(1);
        this.insidefiltem = this.insidefiltem / this.insidefil;
        this.insidefiltem = this.Decimalavg(this.insidefiltem);
        this.insidefilhum = this.insidefilhum / this.insidefil;
        this.insidefilhum = this.Decimalavg(this.insidefilhum);
      }
      if (this.outsidefil != 0) {
        this.outmin = Math.min(...outminmax).toFixed(1);
        this.outmax = Math.max(...outminmax).toFixed(1);
        this.outsidefiltem = this.outsidefiltem / this.outsidefil;
        this.outsidefiltem = this.Decimalavg(this.outsidefiltem);
        this.outsidefilhum = this.outsidefilhum / this.outsidefil;
        this.outsidefilhum = this.Decimalavg(this.outsidefilhum);
      }
    },
    Decimalavg(amout) {
      return amout.toFixed(1);
    },

    link2(item) {
      console.log(item);
      this.$session.set("deviceList", item);
      this.$router.push({
        name: "SensorList",
        params: {
          deviceList: item,
        },
      });
    },
    check(e) {
      console.log(e);
    },
    cancelMapsetting() {
      this.popupActivo4 = false;
      this.getMapsetting();
      // this.reload()
    },
    saveMapsetting(
      item,
      select,
      selectHeight,
      selectDevice,
      selectAreaMap,
      selectLocation,
      filteredList,
      selectHeigth2
    ) {
      var body = {
        red: [parseFloat(item[0].value2[0])],
        yellow: [parseFloat(item[1].value1), parseFloat(item[1].value2)],
        green: [parseFloat(item[2].value1), parseFloat(item[2].value2)],
        blue: [parseFloat(item[3].value2[0])],
        deviceLocation: select,
        deviceHight: this.selectHeightMap,
        device: selectDevice,
        deviceAreaMap: selectAreaMap,
        selectLocation: selectLocation,
        selectHeigth: selectHeigth2,
      };
      console.log(body);
      this.$API
        .put(`dashboard/config/map/1`, body)
        .then((result) => {
          console.log(result.data);
          if (result.status == 200)
            this.$vs.notify({
              title: "Work Order Updated",
              text: "Your work order has been updated",
              color: "primary",
              position: "top-center",
            });
          setTimeout(() => {
            this.$refs["settingMap"].hide();
            this.popupActivo4 = false;
            location.reload();
          }, 1500);
        })
        .catch((err) => {
          if (err.response.status == 500)
            this.$vs.notify({
              title: "Invalid",
              text: "Please try again",
              color: "warning",
              position: "top-center",
            });
        });
      this.allsidefilter_avg(filteredListChart);
      this.fetchChartfilter(filteredListChart);
      location.reload();
    },
    calculateTemp(temp) {},
  },
  computed: {
    filteredList() {
      if (this.select1 == "Default") {
        return this.iconMap;
      } else if (this.select1 == "Custom") {
        if (
          this.selectLocation.length == 0 &&
          this.selectHeightMap.length == 0
        ) {
          this.primeFilter = this.iconMap;
        } else if (
          this.selectLocation.length == 0 &&
          this.selectHeightMap.length != 0
        ) {
          this.primeFilter = this.iconMap.filter((post) => {
            if (this.selectHeightMap.includes(post.height)) return post;
          });
        } else if (
          this.selectLocation.length != 0 &&
          this.selectHeightMap.length == 0
        ) {
          if (this.selectAreaMap.length == 0) {
            this.primeFilter = this.iconMap.filter((post) => {
              if (this.selectLocation.includes(post.type)) return post;
            });
          } else {
            this.primeFilter = this.iconMap
              .filter((post) => {
                if (this.selectLocation.includes(post.type)) return post;
              })
              .filter((post) => {
                if (this.selectAreaMap.includes(post.height)) return post;
              });
          }
        } else {
          if (this.selectLocation == "Inside") {
            let temp = this.iconMap
              .filter((post) => {
                if (this.selectLocation.includes(post.type)) return post;
              })
              .filter((post) => {
                if (this.selectHeightMap.includes(post.height)) return post;
              });
            this.primeFilter = temp;
            this.calculateTemp(this.primeFilter);
          } else if (this.selectLocation == "Outside") {
            let temp = this.iconMap
              .filter((post) => {
                if (this.selectLocation.includes(post.type)) return post;
              })
              .filter((post) => {
                if (this.selectAreaMap.includes(post.height)) return post;
              });
            this.primeFilter = temp;
            this.calculateTemp(this.primeFilter);
          } else {
            let tempArray = this.selectHeightMap.concat(this.selectAreaMap);
            let temp = this.iconMap
              .filter((post) => {
                if (this.selectLocation.includes(post.type)) return post;
              })
              .filter((post) => {
                if (tempArray.includes(post.height)) return post;
              });
            this.primeFilter = temp;
          }
        }
      } else {
        this.currentFilter = this.select1;
        this.primeFilter = this.iconMap.filter((post) => {
          return post.type
            .toString()
            .toLowerCase()
            .includes(this.select1.toLowerCase());
        });
        // ตรงนี้
        try {
          if (this.btnHeigth.length != 0 && this.select1 == "Inside")
            this.primeFilter = this.primeFilter.filter(
              (element) => element.height == this.btnHeigth
            );
          return this.primeFilter;
        } catch (error) {
          return this.primeFilter;
        }
      }
      // if (this.btnHeigth.length != 0)
      //   this.primeFilter = this.primeFilter.filter(
      //     (element) => element.height == this.btnHeigth
      //   );

      if (this.selectDevice.length != 0) {
        let displayDevice = this.primeFilter.filter((post) => {
          if (this.selectDevice.includes(post.id)) return post;
        });

        displayDevice.forEach((element) => {
          let filteredData = displayDevice.filter(
            (data) => data.class == element.class
          );
          if (filteredData.length == 1) {
            element.avgTemp = element.temperature;
            element.selectLocationTemp =
              element.name + " Temperature : " + element.temperature + "°C \n";

            element.avgHumd = element.humidity;
          }
        });
        if (this.btnHeigth.length != 0 && this.select1 != "Custom")
          displayDevice = displayDevice.filter(
            (element) => element.height == this.btnHeigth
          );
        return displayDevice;
      } else if (this.selectDevice.length == 0) return this.primeFilter;
    },
    filteredListChart() {
      if (this.select1 == "Default") {
        return this.iconMapChart;
      } else if (this.select1 == "Custom") {
        if (
          this.selectLocation.length == 0 &&
          this.selectHeightMap.length == 0
        ) {
          this.primeFilter = this.iconMapChart;
        } else if (
          this.selectLocation.length == 0 &&
          this.selectHeightMap.length != 0
        ) {
          this.primeFilter = this.iconMapChart.filter((post) => {
            if (
              this.selectHeightMap.includes(post.height) ||
              post.type == "Outside"
            )
              return post;
          });
        } else if (
          this.selectLocation.length != 0 &&
          this.selectHeightMap.length == 0
        ) {
          if (this.selectAreaMap.length == 0) {
            this.primeFilter = this.iconMapChart.filter((post) => {
              if (
                this.selectLocation.includes(post.type) ||
                post.type == "Inside"
              )
                return post;
            });
          } else {
            this.primeFilter = this.iconMapChart.filter((post) => {
              if (
                this.selectAreaMap.includes(post.height) ||
                post.type == "Inside"
              )
                return post;
            });
          }
        } else {
          if (this.selectLocation == "Inside") {
            let temp = this.iconMapChart
              .filter((post) => {
                if (
                  this.selectLocation.includes(post.type) ||
                  post.type == "Outside"
                )
                  return post;
              })
              .filter((post) => {
                if (
                  this.selectHeightMap.includes(post.height) ||
                  post.type == "Outside"
                )
                  return post;
              });
            this.primeFilter = temp;
            this.calculateTemp(this.primeFilter);
          } else if (this.selectLocation == "Outside") {
            let temp = this.iconMapChart
              .filter((post) => {
                if (
                  this.selectLocation.includes(post.type) ||
                  post.type == "Inside"
                )
                  return post;
              })
              .filter((post) => {
                if (
                  this.selectAreaMap.includes(post.height) ||
                  post.type == "Inside"
                )
                  return post;
              });
            this.primeFilter = temp;
            this.calculateTemp(this.primeFilter);
          } else {
            let tempArray = this.selectHeightMap.concat(this.selectAreaMap);
            let temp = this.iconMapChart
              .filter((post) => {
                if (this.selectLocation.includes(post.type)) return post;
              })
              .filter((post) => {
                if (tempArray.includes(post.height)) return post;
              });
            this.primeFilter = temp;
          }
        }
      } //Inside/Outside
      else {
        this.currentFilter = this.select1;
        var chartData = this.iconMapChart;
        if (this.btnHeigth.length != 0 && this.select1 == "Inside")
          return chartData.filter(
            (element) =>
              element.height == this.btnHeigth || element.type == "Outside"
          );
        else if (this.btnHeigth.length != 0 && this.select1 == "Outside")
          return chartData.filter(
            (element) =>
              element.height == this.btnHeigth || element.type == "Inside"
          );
        else return chartData;
        // return chartData
        // else if (this.btnHeigth.length != 0 && this.select1 == "Outside") chartData = chartData.filter((element) => {
        //   if(element.height == this.btnHeigth || element.type == 'Inside') return chartData
        // })
        // else return chartData;
      }

      // if (this.btnHeigth.length != 0)
      //   this.primeFilter = this.primeFilter.filter(
      //     (element) => element.height == this.btnHeigth
      //   );

      if (this.selectDevice.length != 0) {
        let displayDevice = this.primeFilter.filter((post) => {
          if (this.selectDevice.includes(post.id)) return post;
        });

        displayDevice.forEach((element) => {
          let filteredData = displayDevice.filter(
            (data) => data.class == element.class
          );
          if (filteredData.length == 1) {
            element.avgTemp = element.temperature;
            // element.selectLocationTemp = element.temperature;
            element.avgHumd = element.humidity;
          }
        });
        if (this.btnHeigth.length != 0 && this.select1 != "Custom")
          displayDevice = displayDevice.filter(
            (element) => element.height == this.btnHeigth
          );
        return displayDevice;
      } else if (this.selectDevice.length == 0) return this.primeFilter;
    },
    filterSelectDevice() {
      return this.primeFilter;
    },
    filterHeight() {
      this.primeFilter = this.primeFilter.filter((post) => {
        if (this.selectHeightMap.includes(post.height)) return post;
      });
      return this.primeFilter;
    },
    filterLocation() {
      this.primeFilter = this.iconMapChart.filter((post) => {
        return post.type
          .toString()
          .toLowerCase()
          .includes(this.select1.toLowerCase());
      });
      return this.primeFilter;
    },

    visibleFields() {
      return this.fields.filter((field) => field.visible);
    },
  },
};
</script>
<style scoped>
.txttemp {
  color: #fc8200;
  font-weight: 300;
}
.txthum {
  color: #2ba0ff;
  font-weight: 300;
}
.txtsize {
  font-size: 3.4vh;
}
.img-bg {
  padding: 0;
  background-image: url("../../../../assets/images/frasers/bg/KhonKaen.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
}
.btnGroupH {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #f8f9fa;
  border: 1px solid #212529;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.45;
  -webkit-transition: color 0.15s ease-in-out,
    background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}
.roundedCard {
  border-radius: 20px;
}
.imgMapFreacer {
  max-width: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.vl {
  border-left: 2px solid rgb(197, 197, 197);
  height: 50;
}
.roundedCard {
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 0.75);
}
.imgMapFreacer {
  max-width: 90%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.brdbtn {
  width: 80px;
  border-radius: 20px;
}

.img-wraps {
  position: relative;
  display: inline-block;
}
.img-wraps .Right {
  position: absolute;
  top: 8%;
  right: 7%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  /* font-size: 22px; */
  /* border-radius: 20px; */
  /* background: #ffffff; */
  line-height: 10px;
}
.img-wraps .B1 {
  position: absolute;
  top: 24.5%;
  right: 7%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  /* font-size: 22px; */
  /* border-radius: 20px; */
  /* background: #ffffff; */
  line-height: 10px;
}
.img-wraps .D3 {
  position: absolute;
  top: 44.5%;
  right: 28%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .D5 {
  position: absolute;
  top: 44.5%;
  right: 48.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .D6 {
  position: absolute;
  top: 44.5%;
  right: 59%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .B3 {
  position: absolute;
  top: 24.5%;
  right: 28%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .B4 {
  position: absolute;
  top: 24.5%;
  right: 28%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .B6 {
  position: absolute;
  top: 24.5%;
  right: 59%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .B5 {
  position: absolute;
  top: 24.5%;
  right: 48.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F3 {
  position: absolute;
  top: 65.5%;
  right: 28%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F5 {
  position: absolute;
  top: 65.5%;
  right: 48.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F6 {
  position: absolute;
  top: 65.5%;
  right: 59.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .B7 {
  position: absolute;
  top: 24.5%;
  right: 69.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .Left {
  position: absolute;
  top: 8%;
  right: 69.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) {
  .txtsize {
    font-size: 1.2vh;
  }
}
/* Portrait and Landscape */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
  .txtsize {
    font-size: 1.2vh;
  }
}
</style>